import { Base } from "ui/Scripts/source/framework/base";
import { CalendarTaskCategoryListItem, ICalendarTaskCategoryListItem } from "ui/Scripts/source/models/calendarTaskCategory/calendarTaskCategoryListItem";
import { CodeTitle, ICodeTitle } from "../common/codeTitle";

export interface ICalendarTaskPageData {
    categories: ICalendarTaskCategoryListItem[];
    handlers: ICodeTitle[];
    creators: ICodeTitle[];
}

export class CalendarTaskPageData implements ICalendarTaskPageData {
    categories: CalendarTaskCategoryListItem[];
    handlers: CodeTitle[];
    creators: CodeTitle[];

    constructor();
    constructor(obj: ICalendarTaskPageData);
    constructor(obj?: any) {
        this.categories = Base.getTypedArray(obj ? obj.categories : null, CalendarTaskCategoryListItem);
        this.handlers = Base.getTypedArray(obj ? obj.handlers : null, CodeTitle);
        this.creators = Base.getTypedArray(obj ? obj.creators : null, CodeTitle);
    }
}
